<section class="job-page">
  <app-job-page-header [state]="headerState()"></app-job-page-header>
  @if (jobId) {
    @if (!numericJobId) {
      <p class="job-page__feedback">This run ID is invalid.</p>
    } @else if (jobError()) {
      <p class="job-page__feedback">This run could not be loaded.</p>
    } @else if (toolchain(); as toolchain) {
      <app-toolchain-timeline
        class="job-page__toolchain-timeline"
        [class.job-page__timeline--refreshing]="
          toolchainJob.status() === 'loading' && !!toolchainJob.value()
        "
        [job]="toolchainJob.value()"
        [isInitialLoading]="isInitialLoading()"
        [toolchain]="toolchain"
        (jobStarting)="isStartingJob.set($event)"
        (jobUpdated)="toolchainJob.reload()"></app-toolchain-timeline>
    }
  } @else if (toolchain(); as toolchain) {
    <app-toolchain-timeline
      class="job-page__toolchain-timeline"
      [toolchain]="toolchain"
      (jobStarting)="isStartingJob.set($event)"></app-toolchain-timeline>
  }
</section>
